<template lang="pug">
	.project-create-from-cocos-creator(v-if="showed")
		.card
			.card-header
				span Upload "Cocos Creator" project
			.card-body.collapse.show(v-if="state === 'upload-build-files'")
				span Please upload
				b &nbsp;web-mobile.zip&nbsp;
				span file taken from Cocos Creator build files
				.progress.add-progress(:style="{visibility: isUploading ? 'visible' : 'hidden'}")
					.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
			.card-body.collapse.show(v-if="state === 'confirm-data'")
				.form-horizontal
					.form-group.separator
						span Great! Now confirm parsed data or change it.
				.form-horizontal
					.form-group.separator
						label.col-form-label Project title:
						input.form-control.title(size="16" type="text" v-model="title" @input="title")
			.card-body.collapse.show(v-if="state === 'upload-build-single-file'")
				div(v-if="process === 'create'")
					span Great! The project is created. But in addition you can upload
					b &nbsp;super-html.zip&nbsp;
					span file taken from Cocos Creator build files. This file allow to download single html playables which needed for ad networks like Facebook, Unity Ads and many more. You can create it using "super-html" plugin for Cocos Creator.
					span &nbsp;You can do it later as well at any time.
				div(v-if="process === 'update'")
					span(v-if="!firstUploadSkipped") Great! The project is updated.&nbsp;
					span Now you can upload
					b &nbsp;super-html.zip&nbsp;
					span file taken from Cocos Creator build files. This file allow to download single html playables which needed for ad networks like Facebook, Unity Ads and many more. You can create it using "super-html" plugin for Cocos Creator.
					span &nbsp;You can do it later as well at any time.
				.progress.add-progress(:style="{visibility: isUploading ? 'visible' : 'hidden'}")
					.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (uploadProgress * 100) + '%'}")
			.card-body.collapse.show(v-if="state === 'finish'")
				.form-horizontal
					.form-group.separator
						span(v-if="process === 'create'") Well done! Your cocos creator project ready.
						span(v-if="process === 'update'") Well done! Your cocos creator project updated.
			.card-body.collapse.show(v-if="state === 'loading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
			.card-body.collapse.show(v-if="state === 'error'")
				.text.danger Error: {{errorMessage}}
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-warning(type="button" v-on:click="upload()" v-if="state === 'upload-build-files'")
							i.fa.fa-upload
							span Upload web-mobile.zip file
						button.btn.btn-dark.skip(type="button" v-on:click="skipFirstUpload()" v-if="state === 'upload-build-files' && process === 'update'") Skip
						button.btn.btn-primary(type="button" v-on:click="request()" v-if="state === 'upload-build-files' && process === 'create'") Request playable development
						button.btn.btn-warning(type="button" v-on:click="confirm()" v-if="state === 'confirm-data'")
							i.fa.fa-check
							span Confirm
						button.btn.btn-warning(type="button" v-on:click="upload()" v-if="state === 'upload-build-single-file'")
							i.fa.fa-upload
							span Upload super-html.zip file
						button.btn.btn-primary(type="button" v-on:click="close()" v-if="state === 'upload-build-single-file' || state === 'finish'") Complete
						button.btn.btn-dark.skip(type="button" v-on:click="back()" v-if="state === 'upload-build-single-file' && process === 'update'") Back
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "ProjectCreatePlayableFromCocosCreator",
		mixins: [Screen],
		screen: {
			events: {
				"Show ProjectCreatePlayableFromCocosCreator": function(projectId = null) {

					this.showed = true;
					this.firstUploadSkipped = false;
					this.state = "upload-build-files";
					this.projectId = projectId;
					this.process = projectId ? "update" : "create";

				},
				"Server Data:UploadCocosBuildResult": function(parsedData) {

					this.state = "confirm-data";
					this.title = parsedData.title;

				},
				"Server Data:CocosProjectCreated": function(projectId) {

					this.state = "upload-build-single-file";
					this.projectId = projectId;

				},
				"Server Data:CocosProjectUpdated": function(projectId) {

					this.state = "upload-build-single-file";
					this.projectId = projectId;

				},
				"Server Data:UploadCocosSingleBuildResult": function() {

					this.state = "finish";

				},
				"Server Data:UploadCocosProjectError": function(errorMessage) {

					this.state = "error";
					this.errorMessage = errorMessage;

				}
			}
		},
		data() {

			this.process = "create";
			this.projectId = null;

			return {
				showed: false,
				state: "upload-build-files", // "upload-build-files" > "confirm-data" > "upload-build-single-file" > "finish" || "loading" || "error"
				errorMessage: '',
				title: '',
				isUploading: false,
				uploadProgress: 0,
				firstUploadSkipped: false
			};

		},
		methods: {
			collectData() {

			},
			upload() {

				this.uploadProgress = 0;

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "application/zip";

				input.addEventListener('change', e => {

					this.uploadBuildFiles(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', e => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadBuildFiles(file) {

				let formData = new FormData();

				formData.append("publisherId", Publisher.SelectedPublisher.id);
				if (this.projectId) formData.append("projectId", this.projectId);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/project/upload/${this.state === 'upload-build-files' ? 'cocos' : 'cocosSingle'}`;

				let xhr = new XMLHttpRequest();

				xhr.withCredentials = true;

				xhr.open("POST", url);

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.uploadProgress = e.loaded / e.total;

					}

				};

				xhr.upload.onloadstart = e => {

					this.isUploading = true;

				};

				xhr.upload.onloadend = e => {

					this.isUploading = false;

				};

				xhr.send(formData);

			},
			skipFirstUpload() {

				this.firstUploadSkipped = true;
				this.state = "upload-build-single-file";

			},
			confirm() {

				this.state = "loading";

				Server.sendToServer({
					CreateCocosProjectConfirm: {
						title: this.title
					}
				});

			},
			request() {

				Broadcast.call("Show ProjectCreatePlayableRequest");

			},
			back() {

				this.firstUploadSkipped = false;
				this.state = "upload-build-files";

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.project-create-from-cocos-creator
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		justify-content: center
		align-items: center

		.card
			width: 600px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			label
				white-space: nowrap
				margin-right: 10px

			.form-group
				display: flex
				flex-direction: row
				flex-wrap: nowrap

			.separator
				padding-bottom: 20px
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

			b
				color: #ffc107

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

			.danger
				color: var(--danger)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.btn-ghost-dark, .btn-dark.skip
				float: none
				color: #fff

			.btn-primary, .btn-warning
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

</style>

